import React from 'react';
import { useSelector } from 'react-redux';
import { path } from 'js/utils/ramda.util';
import { MY_ACCOUNT_SIDEBAR_REDUCER } from 'js/store/constants';

import { HomePage } from './components/HomePage';
import { PortalPage } from './components/PortalPage';

import style from './Content.scss';

export const Content = () => {
    const isOpened = useSelector(path([MY_ACCOUNT_SIDEBAR_REDUCER, 'isOpened']));
    const portalPageURL = useSelector(path([MY_ACCOUNT_SIDEBAR_REDUCER, 'portalPageURL']));

    return (
        <>
            <div className={style.content}>
                {isOpened && (
                    portalPageURL ? <PortalPage portalPageURL={portalPageURL} /> : <HomePage />
                )}
            </div>
        </>
    );
};
